<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AvjTZL/tc-custom/9780547630557.jpg?1721429486345" alt="This image is the cover for the book Kit's Law"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kit's Law
      </h1>
      <p class="bookDescription body article font2">
        <b>Morrissey’s acclaimed, bestselling debut. “A Dickensian brawl of a novel . . . never a dull moment! The reader is willingly swept along in the tide.” —<i>St. Louis Post-Dispatch</i></b><br/><br/>In this powerful novel from one of the most gifted storytellers to emerge from Canada since Carol Shields, we find “all the old-fashioned virtues: a vivid sense of place, an intricate and suspenseful plot, and a feisty heroine whom we can’t help rooting for on every page” (Margot Livesey). <br/><br/>Kit Pitman is fourteen and lives in a ramshackle cottage on the outer banks of Newfoundland, where isolation is all she knows. The only visitors are fogbound fishermen and an occasional young man brought ashore to keep the bloodlines clean. But Kit’s isolation is compounded by the mystery that surrounds her family and her illegitimate birth. Her mother, Josie, is mentally disabled and often runs wild among the clapboard houses that dot the shore. Meanwhile, her grandmother Lizzie staunchly guards them both from the disapproving glances pious townsfolk cast their way. But when Lizzie dies suddenly, Kit and her childlike mother are left vulnerable to life’s harsh realities and to unexpected dangers that repeatedly threaten to break them apart. A wrenching story ensues, as Morrissey depicts with exceptional grace the way the lines between mother and daughter in this unlikely relationship, although blurred, are deeply felt. <i>Kit’s Law</i> is a novel of extraordinary, almost mythical power and marks the debut of an enormous new talent.<br/><br/><b>“An extraordinary trinity of women.” —Thomas Keneally, #1 bestselling author of <i>Schindler’s List</i></b><br/><br/><b>“A stunning debut.” —<i>The Telegraph</i></b><br/><br/><b>“Impossible to put down.” —<i>The Sunday Business Post</i></b><br/><br/><b>“Speaks directly to the heart.” —<i>The Globe and Mail</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Donna Morrissey
      </h2>
      
      <p class="authorDescription body article">Donna Morrissey is the award-winning author of four adult novels—Kit’s Law, Downhill Chance, Sylvanus Now, which was shortlisted for the Commonwealth Writers’ Prize, and What They Wanted—as well as the Gemini Award–winning screenplay Clothesline Patch. Morrissey grew up in The Beaches, a small fishing outport in Newfoundland, and now lives in Halifax.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44363c94